

export enum SolicitationStateCodes {
    ApprovalProcess = 1,
    Instrumented = 2,
    Disagreed = 3,
    PendingMonetization = 4,
    Pendant = 5,
    Annulled = 6,
    Analysis = 7,
    GivenUpByBank = 8,
    PendingSent = 9,
    GivenUp= 10,
    Cancelled = 11,
    RejectedByClient = 12,
    PendingApproval = 13,
    ClientApproved = 14
}


export enum SolicitationTypeCodes {
    Automatic = 1,
    SemiAutomatic = 2,
    CPD = 3,
    TraditionalExpress = 4,
    Traditional = 5
}


export enum SolicitationGuaranteeCodes {
    OnlySign = 1,
    MoreSureties = 2
}